import { fetchApi } from "../utils/fetchApi";

export function fetchBuildingforecast({ filter = {}, options = {} }) {  
  return fetchApi({ url: 'buildingforecast', filter, options });
}

